import { useQuery } from "@tanstack/react-query";

import * as api from "./api";

export const useGetUserProfile = () => useQuery({
    queryFn: api.getUserProfile,
    queryKey: ["getUserProfile"]
});